module.exports = __webpack_public_path__ + "static/media/home.3cb7b4bd.svg";